module.exports = __webpack_public_path__ + "images/pages/for_business/pc/sec13_684b980f380f89e6fd87bb51bfb8da8b.jpg";